import React from "react"
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Dropdown from "../../components/UI/Dropdown/Dropdown"
import StoreSelect from "../CartCreate/StoreSelect/StoreSelect"
import config from "../../config/config"
import i18n from "../../i18n";
import { Translation } from "react-i18next"
import { storesService } from "../../services/basis/StoresService"
import { ecommerceService } from "../../services/ecommerce/EcommerceService"
import { connect } from "react-redux"
import * as actionCreators from "../../redux/store/actions/index"

class CartUpdate extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            states: [],
            deliveryModes: [],
            stores: [],
            selectedState: config.DEFAULT_STATE_ID,
            selectedDeliveryMode: this.props.cart && this.props.cart.deliveryMode,
            selectedStore: this.props.cart && this.props.cart.storeId,
        }
    }

    componentDidMount() {
        storesService.states()
            .then(data => {
                this.setState({
                    states: data,
                })
            });
        ecommerceService.deliveryModes()
            .then(data => {
                this.setState({
                    deliveryModes: data,
                })
            });
    }

    selectState = (item) => {
        this.setState({ selectedState: item.stateId });
    }

    selectDeliveryMode = (item) => {
        this.setState({ selectedDeliveryMode: item.id });
    }

    selectStore = (item) => {
        this.setState({ selectedStore: item.id });
    }

    render() {
        const { states, deliveryModes, selectedState, selectedDeliveryMode, selectedStore } = this.state;
        const { cart, move } = this.props;
        if (cart) {
            return (
                <Translation>
                    {t =>
                        <div className="bg">
                            <div className="container">
                                <div className="col-xs-12 col-sm-6 offset-md-6">
                                    <div className="wrapper">
                                        <h1 className="cart-create-title">{t("create.cart.title")}</h1>
                                        <div>
                                            <div className="cart-create-select">
                                                {config.SHOW_STATE_DROPDOWN &&
                                                    <Dropdown
                                                        items={states}
                                                        select={this.selectState}
                                                        label={config.DEFAULT_STATE}
                                                    />
                                                }
                                                <Dropdown
                                                    items={deliveryModes}
                                                    select={this.selectDeliveryMode}
                                                    label={i18n.t(`cart.deliveryMode.${selectedDeliveryMode}`)}
                                                    isDeliveryMode={true}
                                                />
                                                {selectedState && selectedDeliveryMode &&
                                                    <StoreSelect
                                                        state={selectedState}
                                                        deliveryMode={selectedDeliveryMode}
                                                        select={this.selectStore}
                                                        label={cart && cart.storeDescription}
                                                    />
                                                }
                                                <br />
                                                <Row className="justify-content-md-center signup-row">
                                                    <Col sm={4}>
                                                        <button className="custom-button outline"
                                                            onClick={() => move(cart.id, selectedStore)}>
                                                            {t("cart.update")}
                                                        </button>
                                                    </Col>
                                                </Row>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                </Translation>
            );
        } else {
            return null;
        }
    }
}

const mapStateToProps = state => {
    return {
        cart: state.cart.cart
    };
}

const mapDispatchToProps = dispatch => {
    return {
        move: (cartId, storeId) => dispatch(actionCreators.move(cartId, storeId)),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(CartUpdate);
